<template>
    <vx-card no-shadow title="Manage Users and Permissions">
      <a-tabs v-model="model_tab" @change="handlerChangeTab">
        <a-tab-pane key="1" tab="Users">
          <div class="text-right">
            <a-button type="primary" @click="openAddUser" style="border-radius: 3px !important;">Add User</a-button>
          </div>
          <XTable
            ref="user"
            :model="model"
            :is_pagenation="false"
            method="get"
            :search="false"
            @clickRow="(record)=>clickRow(record)"
          >
           <span slot="action" slot-scope="text,record">
            <a-dropdown v-if="!text.record.is_main">
              <a-menu slot="overlay">
               <a-menu-item
                 key="1"
                 @click="changePermission(text.record)"
                 style="border-radius: 3px !important;"
               >
                 <feather-icon icon="UserIcon" svg-classes="text-primary w-4 h-4" />Change Permission
               </a-menu-item>
               <a-menu-item
                 key="2"
                 @click="editUser(text.record)"
                 style="border-radius: 3px !important;"
               >
                 <feather-icon icon="EditIcon" svg-classes="text-success w-4 h-4" />Edit
               </a-menu-item>
               <a-menu-item
                 key="3"
                 @click="deleteUser(text.record)"
                 style="border-radius: 3px !important;"
               >
                 <feather-icon icon="TrashIcon" svg-classes="text-danger w-4 h-4" />Delete
               </a-menu-item>
              </a-menu>
              <a-button style="margin-left: 8px"> Actions <a-icon type="down" /></a-button>
            </a-dropdown>
           </span>
           <span slot="roles" slot-scope="text,record">
             <template v-if="text.record.is_main">Super admin</template>
             <template v-else-if="text.record.roles && Object.keys(text.record.roles).length">
               {{ text.record.roles.title }}
             </template>
             <template v-else>Customized</template>
           </span>
          </XTable>
        </a-tab-pane>
        <a-tab-pane key="2" tab="Roles">
          <div class="text-right">
            <a-button type="primary" @click="openModalRole" style="border-radius: 3px !important;">Add Role</a-button>
          </div>
          <XTable ref="role" :model="modelRoles">
            <span slot="act" slot-scope="text,record">
              <a-dropdown>
                <a-menu slot="overlay">
                  <a-menu-item v-if="text.record.id !== 1" key="1" @click="clickRow(text.record)">Add Permission to Role</a-menu-item>
                  <a-menu-item key="2" @click="roleUserAssign(text.record)">User Assign Role</a-menu-item>
                  <a-menu-item v-if="text.record.creator" key="3" @click="deleteRole(text.record)">Delete</a-menu-item>
                </a-menu>
                <a-button style="margin-left: 8px" @click="is_click_add_time = false"> Actions <a-icon type="down" /></a-button>
              </a-dropdown>
            </span>
          </XTable>
        </a-tab-pane>
      </a-tabs>
      <vs-prompt
          color="primary"
          title="Add User"
          @close="active_prompt = false"
          :active.sync="active_prompt"
          id="verifyPermission"
          buttons-hidden
          :style="{ zIndex: '10' }"
        >
          <a-form :form="form">
            <a-form-item label="First Name" has-feedback>
              <a-input v-decorator="['first_name',{ rules: [{ required: true, message: 'this field is required.' }] }]"/>
            </a-form-item>
            <a-form-item label="L ast Name" has-feedback>
              <a-input v-decorator="['last_name',{ rules: [{ required: true, message: 'this field is required.' }] }]"/>
            </a-form-item>
            <a-form-item label="Email" has-feedback>
              <a-input
                v-decorator="[
                  'email_address',
                  {
                    rules: [
                      {
                        pattern: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                        message: 'The input is not valid E-mail!',
                      },
                      {
                        required: true,
                        message: 'this field is required.',
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
            <a-form-item label="Role" has-feedback>
              <a-select v-decorator="['role_id',{ rules: [{ required: true, message: 'this field is required.' }] }]" allowClear class="w-full">
                <a-select-option v-for="role in roles" :value="role.id" :key="role.id">
                  {{ role.title }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Phone" has-feedback>
              <a-input v-decorator="['phone',{ rules: [{ required: false, message: 'this field is required.' }] }]"/>
            </a-form-item>
          </a-form>
          <vs-button color="primary" class="mt-5 w-full" type="filled" @click="addUserVerify">Save</vs-button>
        </vs-prompt>
      <deleteItem
        :url="`permissions/role-delete/${temp_row}/`"
        subject="Role"
        :ele="$refs.role"
        ref="deleteItemRole"
      />
      <deleteItem
        :url="`account/delete/${temp_row}`"
        subject="User"
        :ele="$refs.user"
        ref="deleteItemUser"
      />
      <a-modal title="Change Permission" :visible="visible_permission" @cancel="visible_permission = false" :footer="null">
        <a-form-item label="Permissions" has-feedback>
          <a-select v-model="permission" allowClear class="w-full">
            <a-select-option v-for="role in roles" :value="role.id" :key="role.id">
              {{ role.title }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <div class="flex gap-2 mt-5">
          <a-button type="primary" @click="handleSubmitClick" :loading="loading" :disabled="!activeBtn" style="border-radius: 3px !important;">Save</a-button>
          <a-button type="primary" ghost @click="visible_permission = false" style="border-radius: 3px !important;">Cancel</a-button>
        </div>
      </a-modal>
      <a-modal title="Create Role" :visible="visibleRole" @cancel="visibleRole = false" :footer="null">
        <a-form :form="form" @submit.prevent="handleRole">
          <a-form-item label="Title">
            <a-input v-decorator="['title',{ rules: [{ required: true, message: 'this field is required.' }] }]"/>
          </a-form-item>
          <div class="flex gap-2 mt-5">
            <a-button type="primary" :loading="loading" html-type="submit" style="border-radius: 3px !important;">Save</a-button>
            <a-button type="primary" ghost @click="visibleRole = false" :disabled="loading" style="border-radius: 3px !important;">Cancel</a-button>
          </div>
        </a-form>
      </a-modal>
      <a-modal title="User Assign Role" :visible="visibleAssign" @cancel="visibleAssign = false" :footer="null">
        <a-form :form="form" @submit.prevent="handleAssignRole">
          <SelectOption
            url="/account/list/"
            label="User"
            field="user_id"
            :required="true"
            method="get"
            placeholder="Find A User"
            class="w-full"
          />
          <div class="flex gap-2 mt-5">
            <a-button type="primary" :loading="loading" html-type="submit" style="border-radius: 3px !important;">Save</a-button>
            <a-button type="primary" ghost @click="visibleAssign = false" :disabled="loading" style="border-radius: 3px !important;">Cancel</a-button>
          </div>
        </a-form>
      </a-modal>
    </vx-card>
</template>

<script>
  import * as TableCol from "./manegeTbl";
  import * as TableColRole from "./roleTbl";
  import XTable from "../../../../components/x-table/XTable";
  import axios from "@/axios"
  import Mixin from "@/views/mixin/mixin";
  import SelectSearch from "@/views/forms/selectSearch";
  import SelectOption from "@/views/forms/SelectOptionSingle";
  import DeleteItem from "@/views/communications/deleteItem";

  export default {
    name:"manegeUser",
    mixins:[Mixin],
    components:{
      DeleteItem,
      SelectOption,
      SelectSearch,
      XTable
    },
    data () {
      return {
        model:null,
        model_job:null,
        active_prompt: false,
        loading: false,
        visible_permission:false,
        permission:null,
        valueSelectRole:null,
        roles: [],
        model_tab: '1',
        // roles
        visibleRole: false,
        visibleAssign: false,
        modelRoles: null,
        temp_row: null
      }
    },
    methods:{
      handlerChangeTab(key){
        this.model_tab = key
      },
      openAddUser(){
        this.email_address  = null
        this.first_name     = null
        this.last_name      = null
        this.phone          = null
        this.active_prompt  = true
        this.edit_mode      = false
      },
      async addUserVerify(){
        this.form.validateFields(async (err,values) => {
          if (!err) {
            try {
              this.$vs.loading({
                container: '#verifyPermission',
                scale: 0.6
              })
              this.edit_mode ? await axios.put(`/account/edit/${this.temp_row}`,values) : await axios.post("/account/add/",values)
              this.$notification['success']({
                message: 'Success',
                description: `To activate your account please click on the link we have sent to your email address.`,
              });
              this.$refs.user.fetch()
            }catch (e) {
              console.log('ERROR CODE', e)
              this.active_prompt = false
              this.$notification['error']({
                message: 'Error',
                description:
                  (e.data.message) ? e.data.message :
                  (e.status === 409) ? 'An account with the specified email address already exists.' :
                  `Add user failed.`,
              });
            }finally {
              this.active_prompt = false
              this.$vs.loading.close()
            }
          }
        })
      },
      async codeParamsVerify(){
        try{
          this.$vs.loading()
          const {data} = await axios.post(`/account/verify/${this.$route.params.code}`)
          this.$store.commit('auth/getToken',data.token)
          this.$store.commit('auth/getUserDetail',data.lawyer_user)
          this.$vs.notify({title:'Successful',text:'Account verify Successful',color:'primary',position:'top-right',time:5000})
          if(!localStorage.getItem("accessToken")){
            this.$router.push('/pages/login')
          }
          // this.$router.push('/settings',()=>{})
        }catch (e) {
          this.$vs.notify({title:'failed',text: e.response.message,color:'danger',position:'top-right',time:5000})
          throw e
        } finally {
          this.$vs.loading.close()
        }
      },
      changePermission(record){
        this.temp_row           = record
        this.permission         = record.permission
        this.visible_permission = true
      },
      async handleSubmitClick(){
        try{
          this.loading = true
          const {temp_row,permission} = this
          await axios.put(`permissions/role-assign`,{ role_id: permission , user_id: temp_row.id })
          this.visible_permission = false
          this.$message.success('Permission Applied.')
          this.$refs.user.fetch()
        }catch (e) {
          this.$message.error('There is no possibility of higher access for you.')
          throw e
        }finally {
          this.loading = false
        }
      },
      openModalRole() {
        this.visibleRole = true
      },
      handleRole() {
        this.form.validateFields(async (err,values) => {
          if (!err) {
            try{
              this.loading = true
              await axios.post('permissions/new-role',values)
              this.visibleRole = false
              this.$refs.role.fetch()
            }catch (e) {
              this.$message.error('Server Error')
              this.visibleRole = true
              throw new Error(e)
            }finally {
              this.loading = false
            }
          }
        })
      },
      async roleUserAssign(record) {
        this.visibleAssign = true
        this.temp_row      = record
      },
      async handleAssignRole() {
        this.form.validateFields(async (err,values) => {
          if (!err) {
            try {
              this.loading = true
              const { temp_row } = this
              await axios.post(`permissions/role-assign`,{ role_id: temp_row.id , user_id: values.user_id  })
              this.visibleAssign = false
              this.$refs.role.fetch()
            }catch (e) {
              this.$message.error('Server Error')
              this.visibleAssign = true
              throw new Error(e)
            }finally {
              this.loading = false
            }
          }
        })
      },
      deleteRole(item) {
        this.temp_row = item.id
        this.$refs.deleteItemRole.open = true
      },
      clickRow(record) {
        if(record.is_main)
          return
        if ((record.roles && record.roles.id !== 1) || (this.model_tab === '2' && record.id !== 1))
          this.$router.push({ name: 'permissions', params: { id: record.id }, query: { role: record.roles ? record.roles.title : record.title || undefined } })
      },
      async getRoles() {
        try {
          const { data } = await axios.post('permissions/roles',{ limit: 100 })
          this.roles = data.rows.filter(item => item.id !== 1)
        }catch (e) {
          throw new Error(e)
        }
      },
      editUser(record) {
        this.active_prompt = true
        this.edit_mode     = true
        this.temp_row      = record.id
        this.$nextTick(()=>this.form.setFieldsValue({ ...record, role_id: record.roles.id || undefined }))
      },
      deleteUser(record) {
        this.$refs.deleteItemUser.open = true
        this.temp_row = record.id
      }
    },
    computed:{
      activeBtn:{
        get(){
          return this.permission
        },
        set(newVal){
          this.permission = newVal
        }
      }
    },
    mounted() {
      if(this.$route.params.code) this.codeParamsVerify()
      this.getRoles()
    },
    created() {
      this.model = TableCol.default
      this.modelRoles = TableColRole.default
    }
  }
</script>

<style>
  .link-verify-user{
    padding: 10px;
    padding-bottom: 0px !important;
  }
  .link-verify-user .vs-input{
    width: 100%;
    margin: 2em 0;
  }
  .field{
    margin-bottom: 0.5em !important;
  }
  [dir] .con-select .vs-select--input {
    padding: 8px !important;
  }

</style>


